var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlink = function SvgUnlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".unlink_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.999v-2.5M5 8.499H2.5M6.318 5.317 4.55 3.55M10.934 19.076l-3.4 3.4a3.51 3.51 0 0 1-4.949 0l-1.061-1.06a3.51 3.51 0 0 1 0-4.95l3.4-3.4M15.5 8.5h4.377a3.685 3.685 0 0 1 3.623 3.576v2a3.576 3.576 0 0 1-3.647 3.424H15.5",
    className: "unlink_svg__a"
  })));
};
export default SvgUnlink;